import React, { useEffect } from 'react'
import useReviewersActions from '../hooks/useReviewersActions'
import { useReviewersContext } from '../context/reviewers/ReviewersProvider'
import Pagination from '../../core/components/UI/Pagination'
import ReviewersGrid from '../components/reviewers-page/ReviewersGrid'
import Breadcrumb from '../../core/components/UI/Breadcrumb'
import {  useSearchParams } from "react-router-dom"

const links = [
  {
    id: 1,
    label: 'استبيان',
    isActive: true,
    to: '/sponsors',
  },
]
export default function ReviewersPage() {
  const [searchParams] = useSearchParams()
  const { getReviewers } = useReviewersActions()
  const { reviewersState } = useReviewersContext()
  useEffect(() => {
    getReviewers()
  }, [searchParams])
  return (
    <>
      <Breadcrumb links={links} />
      <div className="flex flex-col w-full gap-2">
        <ReviewersGrid
          isLoading={reviewersState.isLoading}
          reviewers={reviewersState.reviewers}
        />
        <Pagination
          isLoading={reviewersState.isLoading}
          pagination={reviewersState.pagination}
        />
      </div>
    </>
  )
}
